export const userColumnsConfig = {
  GENDER: "Gender",
  NAME: "Name",
  EMAIL: "Email",
  SOCIAL_TYPE: "Social Type",
  STATUS: "Status",
  ACTIONS: "Actions",
  messages: "Are you sure you want to delete this user?",
};